import React from 'react';
import './alert-message.scss';
import { ReactComponent as Icon } from 'assets/svg/error-outline-icon.svg';


interface AlertMessageProps {
    title: string;
    message: string;
    type: 'info' | 'warning' | 'error';
    children?: React.ReactNode;

}

const AlertMessage: React.FC<AlertMessageProps> = ({ title, message, type, children }) => {
    return (
        <div className={`alert-message alert-message--${type}`}>
            <h3 className="alert-message__title">
                <Icon />
                {title}</h3>
            <p className="alert-message__message">{message}</p>
            {children}
        </div>
    );
};

export default AlertMessage;